module.exports = __webpack_public_path__ + "img/facebook-icon.5c6c9bfd.svg";